
































































































import { Vue, Component, Prop } from "vue-property-decorator";

interface StatusOptions {
  status?: string;
  header: string;
  headerTooltip?: string;
  content: string;
  contentPrependIcon?: string;
  contentTooltip?: string;
  footer?: string;
  footerTooltip?: string;
  footerLink?: string;
  footerLinkText?: string;
  footerSeparator?: boolean;
}

@Component({})
export default class StatusCard extends Vue {
  @Prop() options!: StatusOptions;
  @Prop({ default: "auto" }) height!: string | number;

  //  @Getters
  get heightStyle() {
    return { height: typeof this.height === "number" ? `${this.height}px` : this.height };
  }

  typeClass(): string {
    switch (this.options.status) {
      case "Ok":
        return "status-card--ok";
      case "NotOk":
        return "status-card--not-ok";
      case "BenchMarking":
        return "status-card--benchmarking";
      case "Observe":
        return "status-card--observe";
      default:
        return "status-card--default";
    }
  }
}
